module.exports = __webpack_public_path__ + "static/media/CooperHewitt-Book.375f05aa.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/CooperHewitt-Book.otf
// module id = ./src/assets/fonts/CooperHewitt-Book.otf
// module chunks = 0